"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkTypePreference = void 0;
exports.instanceOfWorkTypePreference = instanceOfWorkTypePreference;
exports.WorkTypePreferenceFromJSON = WorkTypePreferenceFromJSON;
exports.WorkTypePreferenceFromJSONTyped = WorkTypePreferenceFromJSONTyped;
exports.WorkTypePreferenceToJSON = WorkTypePreferenceToJSON;
exports.WorkTypePreferenceToJSONTyped = WorkTypePreferenceToJSONTyped;
/**
 *
 * @export
 */
exports.WorkTypePreference = {
    PerDiem: 'PER_DIEM',
    LongTerm: 'LONG_TERM',
    OpenToAnything: 'OPEN_TO_ANYTHING'
};
function instanceOfWorkTypePreference(value) {
    for (const key in exports.WorkTypePreference) {
        if (Object.prototype.hasOwnProperty.call(exports.WorkTypePreference, key)) {
            if (exports.WorkTypePreference[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function WorkTypePreferenceFromJSON(json) {
    return WorkTypePreferenceFromJSONTyped(json, false);
}
function WorkTypePreferenceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function WorkTypePreferenceToJSON(value) {
    return value;
}
function WorkTypePreferenceToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=WorkTypePreference.js.map